const defaultConfig = require('./default.config');
const qaConfig = require('./qa.config');
const stagingConfig = require('./staging.config');
const productionConfig = require('./production.config');

let envConfig = null;
if (process.env.REACT_APP_ENV === 'qa') envConfig = qaConfig;
if (process.env.REACT_APP_ENV === 'staging') envConfig = stagingConfig;
if (process.env.REACT_APP_ENV === 'production') envConfig = productionConfig;

module.exports = { ...defaultConfig, ...envConfig };



// WEBPACK FOOTER //
// ./src/config/index.js